import { Tooltip as KitTooltip } from 'components/ui/tooltip';
import { ReactElement } from 'react';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

type Props = {
    text?: string | string[];
    className?: string;
    children: ReactElement;
};

/** A tooltip whose text is one translation key, or several rendered as separate lines. */
const Tooltip = ({ text, className, children }: Props): JSX.Element => {
    // Without text there is no tooltip to hang on the trigger, so the trigger renders bare.
    if (!text || text.length === 0) return children;

    return (
        <KitTooltip
            className={cn('w-fit text-center', className)}
            content={
                Array.isArray(text) ? (
                    <span className="flex flex-col gap-2">
                        {text.map((item) => (
                            <span key={item}>{t(item)}</span>
                        ))}
                    </span>
                ) : (
                    t(text)
                )
            }
        >
            {children}
        </KitTooltip>
    );
};

export default Tooltip;
